import { render, staticRenderFns } from "./UcCurrencyBadge.yaml?vue&type=template&id=52759c48&component"
import script from "./UcCurrencyBadge.yaml?vue&type=script&lang=ts&component"
export * from "./UcCurrencyBadge.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports